import React from 'react';
import { Icon, Button, Hr, ModalHeader } from 'LocalGluons';
import { Dimensions, SafeAreaView, ScrollView, View, Text } from 'react-native';
import { t } from 'Locale';
import portraitStyles from './VoyoUpsell.jss';

interface VoyoUpsellProps {
    close: () => void;
}

const VoyoUpsell = ({ close }: VoyoUpsellProps): JSX.Element => {
    const styles = portraitStyles;
    const buttonStyle = { button: styles.button };

    const { width } = Dimensions.get('window');

    return (
        <SafeAreaView style={styles.viewContainer}>
            <ModalHeader
                style={{
                    iconContainer: styles.iconCloseContainer
                }}
                onPress={close}
            />
            <ScrollView contentContainerStyle={styles.scrollContainer}>
                <View style={styles.windowMobile}>
                    <View style={styles.logoBox}>
                        <Icon style={styles.logo} name="voyo_logo" />
                    </View>
                    <View style={styles.headerContainer}>
                        <Text style={styles.title}>
                            {t('PARTNER.VOYO.ORDER.PACKAGE2_TITLE_MOBILES')}
                        </Text>
                    </View>
                    <Hr style={styles.hrStyle} />
                    <View style={styles.descriptionBox}>
                        <Text style={styles.greyText}>
                            {t('PARTNER.VOYO.ORDER.PACKAGE2_DESCRIPTION_MOBILES')}
                        </Text>
                    </View>

                    <View style={styles.iconsContainer}>
                        <View
                            style={
                                width > 320
                                    ? styles.innerItemContainer
                                    : styles.innerItemContainerSmaller
                            }
                        >
                            <Icon style={styles.itemIcon} name="telekom" />
                            <Text style={styles.itemText}>
                                {t('PARTNER.VOYO.TELEKOM_APP_INFO')}
                            </Text>
                        </View>
                        <View
                            style={
                                width > 320
                                    ? styles.innerItemContainer
                                    : styles.innerItemContainerSmaller
                            }
                        >
                            <Icon style={styles.itemIcon} name="phoneNumber" />
                            <Text style={styles.itemText}>
                                {t('PARTNER.VOYO.PHONE_NUMBER_INFO')}
                            </Text>
                        </View>
                        <View
                            style={
                                width > 320
                                    ? styles.innerItemContainer
                                    : styles.innerItemContainerSmaller
                            }
                        >
                            <Icon style={styles.itemIcon} name="store" />
                            <Text style={styles.itemText}>
                                {t('PARTNER.VOYO.TELEKOM_STORE_INFO')}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.buttonContainer}>
                        <Button
                            style={buttonStyle}
                            title={t('PARTNER.VOYO.UNDERSTAND_BTN')}
                            onPress={close}
                        />
                    </View>
                </View>
            </ScrollView>
        </SafeAreaView>
    );
};

export default VoyoUpsell;
